import { render, staticRenderFns } from "./RoutingAreaShow.vue?vue&type=template&id=1d566e59&"
import script from "./RoutingAreaShow.vue?vue&type=script&lang=js&"
export * from "./RoutingAreaShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports